import {RouterModule, Routes} from '@angular/router';
import {AuthGuard} from './_guards/auth.guard';
import {ActionItemTemplateComponent} from './components/actionItemTemplate/actionItemTemplate.component';
import {AlertsComponent} from './components/alerts';
import {ApiKeysComponent} from './components/apiKeys';
import {AssessmentComponent} from './components/assessment/assessment.component';
import {AssessmentAnswersComponent} from './components/assessmentAnswers/assessmentAnswers.component';
import {AssessmentEditComponent} from './components/assessmentEdit/assessment-edit.component';
import {AssessmentFindingsComponent} from './components/assessmentFindings/assessmentFindings.component';
import {ThirdPartyAssessmentComponent} from './components/thirdPartyAssessmentFindings/thirdPartyAssessmentFindings.component'
import {AssessmentsComponent} from './components/assessments/assessments.component';
import {AuditComponent} from './components/audit/audit.component';
import {AzureComponent} from './components/azure/azure.component';
import {BulletinsComponent} from './components/bulletins/bulletins.component';
import {ChangePasswordComponent} from './components/changePassword';
import {CidReportComponent} from './components/cidReport';
import {ClientProfileComponent} from './components/clientProfile';
import {CloneProjectComponent} from './components/cloneProject/cloneProject.component';
import {CloneSourceComponent} from './components/cloneSource/cloneSource.component';
import {ControlItemComponent} from './components/controlItem';
import {ControlItemsComponent} from './components/controlItems';
import {ControlItemUpdatesComponent} from './components/controlItemUpdates';
import {CreateProjectComponent} from './components/createProject';
import {CreateTenantComponent} from './components/createTenant';
import {DictionaryComponent} from './components/dictionary/dictionary.component';
import {DocumentsComponent} from './components/documents';
import {EvidenceArchiveComponent} from './components/evidenceArchive';
import {ForgotPasswordComponent} from './components/forgotPassword';
import {HomeComponent} from './components/home/home.component';
import {AssessmentManagerEditComponent, AssessmentManagerListComponent, AssessmentManagerViewComponent} from './components/assessmentManager';
import {
  ImplementationControlStatementComponent
} from './components/implementationControlStatement/implementation-control-statement.component';
import {IncidentResponseComponent} from './components/incidentResponse/incidentResponse.component';
import {InqSsoComponent} from './components/inqSso/inqSso.component';
import {IntegrationsComponent} from './components/integrations';
import {InviteSurveyUserComponent} from './components/inviteSurveyUser/invite.survey-user.component';
import {InviteUserComponent} from './components/inviteUser';
import {ItProfileComponent} from './components/itProfile';
import {ItProfileTemplateEditComponent} from './components/itProfileTemplateEdit/it-profile-template-edit.component';
import {LogComponent} from './components/log/log.component';
import {LoginComponent} from './components/login';
import {MapControlItemsComponent} from './components/mapControlItems/mapControlItems.component';
import {MapProjectControlItemsComponent} from './components/mapProjectControlItems';
import {MapWorkstreamItemsComponent} from './components/mapWorkstreamItems';
import {SetupEmailMfaComponent} from './components/mfa/setupEmail/setup-email.component';
import {SetupTotpComponent} from './components/mfa/setupTotp/setup-totp.component';
import {MfaStatusComponent} from './components/mfa/status/mfa-status.component';
import {MultiLoginComponent} from './components/multi-login/multi-login.component';
import {MyProfileComponent} from './components/myProfile/my-profile.component';
import {PoamComponent} from './components/poam';
import {PolicyComponent} from './components/policy/policy.component';
import {ProjectComponent} from './components/project';
import {ProjectNewComponent} from './components/projectNew/projectNew.component';
import {ProjectPoamsComponent} from './components/projectPoams/projectPoams.component';
import {ProjectPoliciesComponent} from './components/projectPolicies/projectPolicies.component';
import {ProjectsComponent} from './components/projects';
import {ProjectStatusComponent} from './components/projectStatus';
import {RedirectComponent} from './components/redirect';
import {RequestListComponent} from './components/request-list/request-list.component';
import { RiskComponent } from './components/risk/risk.component';
import { RizkListReportComponent } from './components/rizkListReport/rizkListReport.component';
import {SapProfileComponent} from './components/sapProfile/sap.profile.component';
import {SarProfileComponent} from './components/sarProfile/sar.profile.component';
import {
  SharedResponsibilityReportComponent
} from './components/sharedResponsibilityReport/sharedResponsibilityReport.component';
import {SupportConsoleComponent} from './components/support-console/support-console.component';
import {SupportLoginComponent} from './components/support-login/support-login.component';
import {TenantPermissionsComponent} from './components/tenantPermissions';
import {TenantsComponent} from './components/tenants';
import {TrainingComponent} from './components/training/training.component';
import {TrainingEditComponent} from './components/trainingEdit/training-edit.component';
import {TrainingsComponent} from './components/trainings/trainings.component';
import {
  UnsubscribeNotificationComponent
} from './components/unsubscribeNotification/unsubscribe.notification.component';
import {UpdateControlsComponent} from './components/updateControls';
import {UserComponent} from './components/user';
import {UsersComponent} from './components/users';
import {WorkstreamsComponent} from './components/workstreams';
import {OidcCallbackComponent} from "./components/oidcCallback/oidc-callback.component";
import {ConMonProfileComponent} from "./components/conMonProfile/con-mon.profile.component";
import {PoamListComponent} from "./components/poamList/poam-list.component";
import {Role, RoleHelper} from "./helpers";
import { EvidenceCentralComponent } from "./components/evidence-central/evidence-central.component";
import { TrustBuilderComponent } from './components/trustBuilder/trustBuilder.component';
import {GenericControlsComponent} from "./components/genericControls/genericControls.component";
import {GlobalPoamListComponent} from "./components/globalPoamList/global-poam-list.component";
import {GlobalDeviceListComponent} from "./components/globalDeviceList/global-device-list.component";
import { CveComponent } from "./components/cve/cve.component";
import { FleetsComponent } from "./components/fleets/fleets.component";
import { FleetDashboardDetailComponent } from './components/fleetDashboardDetail/fleet.dashboard.detail.component';
import {GlobalTrustReportComponent} from "./components/globalTrustReport/globalTrustReport.component";
import {TrustBuilderViewComponent} from "./components/trustBuilderView/trustBuilderView.component";

const appRoutes: Routes = [
  {path: '', component: RedirectComponent, canActivate: [AuthGuard]},
  {path: 'redirect', component: RedirectComponent, canActivate: [AuthGuard]},
  {
    path: 'projects',
    component: ProjectsComponent,
    canActivate: [AuthGuard],
    data: {func: RoleHelper.isDashboardVisible}
  },
  {path: 'login', component: LoginComponent},
  {path: 'oidc-callback', component: OidcCallbackComponent},
  {path: 'sso', component: InqSsoComponent},
  {path: 'change-password', component: ChangePasswordComponent},
  {path: 'mfa', component: MfaStatusComponent},
  {path: 'mfa/totp', component: SetupTotpComponent},
  {path: 'mfa/email', component: SetupEmailMfaComponent},
  {path: 'users', component: UsersComponent, canActivate: [AuthGuard], data: {func: RoleHelper.isUsersVisible}},
  {path: 'home', component: HomeComponent, canActivate: [AuthGuard]},
  {
    path: 'users/user/:userId',
    component: UserComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'projects/project/create',
    component: CreateProjectComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'projects/project/:projectId/status',
    component: ProjectStatusComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'projects/project/:projectId/assessments',
    component: AssessmentManagerListComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'projects/project/:projectId/assessments/new',
    component: AssessmentManagerEditComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'projects/project/:projectId/assessments/:assessmentId/edit',
    component: AssessmentManagerEditComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'projects/project/:projectId/assessments/:assessmentId',
    component: AssessmentManagerViewComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'projects/project/:projectId/mapControlItems',
    component: MapProjectControlItemsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'projects/project/:projectId/:projectControlItemId',
    component: ProjectNewComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'projects/projectNew/:projectId/implementationStatus/:implementationStatus',
    component: ProjectNewComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'projects/project/:projectId/implementationStatus/:implementationStatus',
    component: ProjectNewComponent,
    canActivate: [AuthGuard],
  },
  {path: 'invite', component: InviteUserComponent, canActivate: [AuthGuard]},
  {
    path: 'inviteSurvey',
    component: InviteSurveyUserComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'projects/projectNew/:projectId',
    component: ProjectNewComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'projects/project/:projectId',
    component: ProjectNewComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'controlItems',
    component: ControlItemsComponent,
    canActivate: [AuthGuard],
    runGuardsAndResolvers: 'always',
  },
  {
    path: 'controlItems/updates',
    component: ControlItemUpdatesComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'controlItems/mapControlItems/:complianceAreaId',
    component: MapControlItemsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'controlItems/mapWorkstreamItems/:complianceAreaId',
    component: MapWorkstreamItemsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'controlItems/:controlItemId',
    component: ControlItemComponent,
    canActivate: [AuthGuard],
  },
  {path: 'tenants', component: TenantsComponent, canActivate: [AuthGuard], data: {func: RoleHelper.isTenantsVisible}},
  {path: 'createAccount', component: CreateTenantComponent},
  {path: 'createAccount/:secret', component: CreateTenantComponent},
  {path: 'forgotPassword', component: ForgotPasswordComponent},
  {path: 'forgotpassword', component: ForgotPasswordComponent},
  {path: 'changePassword', component: ChangePasswordComponent},
  {path: 'unsubscribe', component: UnsubscribeNotificationComponent},
  {
    path: 'clientProfile',
    component: ClientProfileComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'profiles/itProfile',
    component: ItProfileComponent,
    canActivate: [AuthGuard],
    data: {func: RoleHelper.isItProfileTemplatesVisible}
  },
  {
    path: 'profiles/itProfile/:id',
    component: ItProfileComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'profiles/itProfile/edit',
    component: ItProfileTemplateEditComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'profiles/itProfile/:id/edit',
    component: ItProfileTemplateEditComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'profiles/sapProfile',
    component: SapProfileComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'profiles/sapProfile/:id',
    component: SapProfileComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'profiles/sarProfile',
    component: SarProfileComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'profiles/sarProfile/:id',
    component: SarProfileComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'profiles/conMonProfile',
    component: ConMonProfileComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'profiles/conMonProfile/:id',
    component: ConMonProfileComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'assessments',
    component: AssessmentsComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'assessment/:id/edit',
        component: AssessmentEditComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'assessment/:assessmentId',
        component: AssessmentComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'assessment/:assessmentId/answer',
        component: AssessmentAnswersComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'assessment/:assessmentId/:answerId',
        component: AssessmentComponent,
        canActivate: [AuthGuard],
      },
    ],
  },
  {path: 'alerts', component: AlertsComponent, canActivate: [AuthGuard]},
  {
    path: 'tenants/updateControls',
    component: UpdateControlsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'projects/poam/:projectId',
    component: PoamComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'projects/poam/edit/:projectId',
    component: PoamListComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'projects/cidreport/:projectId',
    component: CidReportComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'projects/assessmentFindings/:projectId',
    component: AssessmentFindingsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'projects/thirdPartyAssessment/:projectId',
    component: ThirdPartyAssessmentComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'bulletins',
    component: BulletinsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'training',
    component: TrainingsComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'edit/:trainingId',
        component: TrainingEditComponent,
        canActivate: [AuthGuard],
      },
      {path: '', component: TrainingComponent, canActivate: [AuthGuard]},
      {
        path: 'create',
        component: TrainingEditComponent,
        canActivate: [AuthGuard],
      },
      {
        path: ':trainingId',
        component: TrainingComponent,
        canActivate: [AuthGuard],
      },
    ],
  },
  {path: 'log', component: LogComponent, canActivate: [AuthGuard]},
  {
    path: 'workstreams',
    component: WorkstreamsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'policy/:policyId',
    component: PolicyComponent,
    canActivate: [AuthGuard],
  },
  {path: 'policy', component: PolicyComponent, canActivate: [AuthGuard]},
  {
    path: 'implementationControlStatements',
    component: ImplementationControlStatementComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'assessment',
    component: AssessmentComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'assessment/:assessmentId',
    component: AssessmentComponent,
    canActivate: [AuthGuard],
  },
  {path: 'apiKeys', component: ApiKeysComponent, canActivate: [AuthGuard]},
  {path: 'azure', component: AzureComponent, canActivate: [AuthGuard]},
  {
    path: 'projects/clone',
    component: CloneProjectComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'projects/clone/:sourceId',
    component: CloneSourceComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'projects/clone/:sourceId/:id',
    component: CloneSourceComponent,
    canActivate: [AuthGuard],
  },
  { path: 'risks', component: RiskComponent, canActivate: [AuthGuard] },
  {
    path: 'risks/:riskSet',
    component: RiskComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'risks/rizklist-report',
    component: RizkListReportComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'tenantPermissions',
    component: TenantPermissionsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'integrations',
    component: IntegrationsComponent,
    canActivate: [AuthGuard],
  },
  {path: 'audit', component: AuditComponent, canActivate: [AuthGuard]},
  {
    path: 'audit/:auditId',
    component: AuditComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'mapping/:mappingTemplateId',
    component: ControlItemsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'support',
    component: SupportConsoleComponent,
    canActivate: [AuthGuard],
  },
  {path: 'support-login/:i', component: SupportLoginComponent},
  {
    path: 'actionPlanTemplates',
    component: ActionItemTemplateComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'incidentResponse',
    component: IncidentResponseComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'dictionaries',
    component: DictionaryComponent,
    canActivate: [AuthGuard],
    data: {func: RoleHelper.isUsersVisible}
  },
  {
    path: 'projects/sharedResponsibilityReport/:projectId',
    component: SharedResponsibilityReportComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'requestList/:requestListGroupId',
    component: ProjectsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'requestList',
    component: RequestListComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'multilogin',
    component: MultiLoginComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'projects/policy/:projectId',
    component: ProjectPoliciesComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'myProfile',
    component: MyProfileComponent,
    canActivate: [AuthGuard],
  },
  {
     path: 'documents',
     component: DocumentsComponent,
     canActivate: [AuthGuard],
   },
  {
    path: 'documents/requestList',
    component: RequestListComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'documents/archive',
    component: EvidenceArchiveComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'documents/archive/:projectId',
    component: EvidenceArchiveComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'projects/poams/:projectId',
    component: ProjectPoamsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'assessment',
    component: AssessmentComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'assessment/:assessmentId',
    component: AssessmentComponent,
    canActivate: [AuthGuard],
  },
  {path: 'apiKeys', component: ApiKeysComponent, canActivate: [AuthGuard]},
  {path: 'azure', component: AzureComponent, canActivate: [AuthGuard]},
  {
    path: 'projects/clone',
    component: CloneProjectComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'projects/clone/:sourceId',
    component: CloneSourceComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'projects/clone/:sourceId/:id',
    component: CloneSourceComponent,
    canActivate: [AuthGuard],
  },
  {path: 'risks', component: RiskComponent, canActivate: [AuthGuard]},
  {
    path: 'risks/:riskSet',
    component: RiskComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'tenantPermissions',
    component: TenantPermissionsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'integrations',
    component: IntegrationsComponent,
    canActivate: [AuthGuard],
  },
  {path: 'audit', component: AuditComponent, canActivate: [AuthGuard]},
  {
    path: 'audit/:auditId',
    component: AuditComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'mapping/:mappingTemplateId',
    component: ControlItemsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'support',
    component: SupportConsoleComponent,
    canActivate: [AuthGuard],
  },
  {path: 'support-login/:i', component: SupportLoginComponent},
  {
    path: 'actionPlanTemplates',
    component: ActionItemTemplateComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'incidentResponse',
    component: IncidentResponseComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'dictionaries',
    component: DictionaryComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'projects/sharedResponsibilityReport/:projectId',
    component: SharedResponsibilityReportComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'requestList/:requestListGroupId',
    component: ProjectsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'requestList',
    component: RequestListComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'multilogin',
    component: MultiLoginComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'projects/policy/:projectId',
    component: ProjectPoliciesComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'myProfile',
    component: MyProfileComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'projects/poams/:projectId',
    component: ProjectPoamsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'projects/globalPoams',
    component: GlobalPoamListComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'cve',
    component: CveComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'globalDevices',
    component: GlobalDeviceListComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'evidence-central',
    component: EvidenceCentralComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'trustBuilder',
    component: TrustBuilderComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'trustBuilderView',
    component: TrustBuilderViewComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'multiverse',
    component: GenericControlsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'fleets',
    component: FleetsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'fleet-home/:fleetId',
    component: FleetDashboardDetailComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'trustReport',
    component: GlobalTrustReportComponent
  }
];

export const routing = RouterModule.forRoot(appRoutes, {
  onSameUrlNavigation: 'reload',
});
